import clsx from 'clsx'

import s from './CategorySection.module.css'

type Props = {
  children: React.ReactNode
  title: string
  icon?: React.ReactNode
  isContentIdeasPage?: boolean
}

const CategorySection = ({
  children,
  title,
  icon,
  isContentIdeasPage,
}: Props) => {
  return (
    <div className={s.wrapper}>
      <h4 className={s.header}>
        {icon} {title}
      </h4>
      <div
        className={clsx(s.categories, {
          [s.contentIdeas]: isContentIdeasPage,
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default CategorySection
